import Modal from './Modal.js';
import { useLanguage } from '../context/LanguageContext.js';
import { usei18n } from '../i18n/i18n.js';
import './ClearDataModal.css';

const ClearDataModal = ({ onConfirm, onClose }) => {
    const { language } = useLanguage();
    const i18n = usei18n(language);
    return (
        <Modal onClose={onClose} onBackdropClick={onClose} id="clear-data">
            <p className="warning-message">{i18n('modal.clearData.message')}</p>
            <button className="warning-button delete" onClick={onConfirm}>{i18n('modal.clearData.confirm')}</button>
        </Modal>
    );
}

export default ClearDataModal;
